import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// react-bootstrap
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

// project-imports
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { logout } from '../../services/auth.service';

// assets
import Img2 from 'assets/images/user/avatar-2.png';

// =============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  // Leer el usuario de forma segura
  let user = { fullName: 'Usuario', email: '' };
  try {
    const raw = localStorage.getItem('user');
    if (raw) user = JSON.parse(raw);
  } catch {
    /* noop */
  }

  const handleConfirmLogout = () => {
    setLoggingOut(true);
    // Pequeño delay para que se vea el spinner antes de redirigir
    setTimeout(() => {
      logout(); // borra localStorage + redirige a /login
    }, 400);
  };

  return (
    <>
      <header className="pc-header">
        <div className="header-wrapper">
          <div className="me-auto pc-mob-drp">
            <Nav className="list-unstyled">
              <Nav.Item className="pc-h-item pc-sidebar-collapse">
                <Nav.Link
                  as={Link}
                  to="#"
                  className="pc-head-link ms-0"
                  id="sidebar-hide"
                  onClick={() => handlerDrawerOpen(!drawerOpen)}
                >
                  <i className="ph ph-list" />
                </Nav.Link>
              </Nav.Item>

              <Nav.Item className="pc-h-item pc-sidebar-popup">
                <Nav.Link
                  as={Link}
                  to="#"
                  className="pc-head-link ms-0"
                  id="mobile-collapse"
                  onClick={() => handlerDrawerOpen(!drawerOpen)}
                >
                  <i className="ph ph-list" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="ms-auto">
            <Nav className="list-unstyled">
              <Dropdown className="pc-h-item" align="end">
                <Dropdown.Toggle
                  className="pc-head-link arrow-none me-0"
                  variant="link"
                  id="user-profile-dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="ph ph-user-circle" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-user-profile pc-h-dropdown p-0 overflow-hidden">
                  <Dropdown.Header className="bg-primary">
                    <Stack direction="horizontal" gap={3} className="my-2">
                      <div className="flex-shrink-0">
                        <Image
                          src={user.avatar || Img2}
                          alt="user-avatar"
                          className="user-avatar wid-35"
                          roundedCircle
                        />
                      </div>
                      <Stack gap={1}>
                        <h6 className="text-white mb-0">
                          {user.fullName || user.nombre_completo || 'Usuario'} 🖖
                        </h6>
                        <span className="text-white text-opacity-75">{user.email}</span>
                      </Stack>
                    </Stack>
                  </Dropdown.Header>

                  <div className="dropdown-body">
                    <div
                      className="profile-notification-scroll position-relative"
                      style={{ maxHeight: 'calc(100vh - 225px)' }}
                    >
                      <Dropdown.Item as={Link} to="/agricola/mi-perfil" className="justify-content-start">
                        <i className="ph ph-user me-2" />
                        Mi Perfil
                      </Dropdown.Item>

                     
                      <div className="d-grid my-2 px-3">
                        <Button
                          variant="danger"
                          onClick={() => setShowLogoutModal(true)}
                        >
                          <i className="ph ph-sign-out align-middle me-2" />
                          Cerrar Sesión
                        </Button>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </div>
        </div>
      </header>

      {/* ============ MODAL DE CONFIRMACIÓN ============ */}
      <Modal
        show={showLogoutModal}
        onHide={() => !loggingOut && setShowLogoutModal(false)}
        centered
        backdrop={loggingOut ? 'static' : true}
      >
        <Modal.Header closeButton={!loggingOut}>
          <Modal.Title className="fw-bold">
            <i className="ph ph-sign-out me-2 text-danger" />
            Cerrar Sesión
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">
            ¿Estás seguro que deseas cerrar tu sesión?
          </p>
          <small className="text-muted">
            Tendrás que volver a iniciar sesión para acceder al sistema.
          </small>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowLogoutModal(false)}
            disabled={loggingOut}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmLogout}
            disabled={loggingOut}
          >
            {loggingOut ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                  role="status"
                />
                Cerrando sesión...
              </>
            ) : (
              <>
                <i className="ph ph-sign-out me-1" />
                Sí, cerrar sesión
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}